import React from 'react'
import { OutboundLink } from 'react-ga'
import styles from './CardPrices.module.scss'
import { v4 } from 'uuid'
import { tcgplayerLink } from '../util'

const CardPrices = ({ prices }) => {
  const priceSources = ['cardkingdom', 'tcgplayer', 'coolstuffinc']
  const cardkingdomUrl = prices?.cardkingdom
    ? `${prices?.cardkingdom.url.split('?')[0]}?partner=edhrec&utm_source=cardgamer&utm_medium=affiliate&utm_campaign=cardgamer&partner_args=cardgamer`
    : 'https://cardkingdom.com'
  const tcgplayerUrl = prices?.tcgplayer?.url
  ? prices.tcgplayer.url.includes('partner.tcgplayer.com') 
      ? prices.tcgplayer.url.replace("subId1=spellvoid", "subId1=cardgamer")  
      : tcgplayerLink({
        subId1: `cardgamer,cardprice`,
        u: prices.tcgplayer.url.split('?')[0],
      })
    : '#'
  const priceLinks = {
    cardhoarder: () => (
      <OutboundLink
        alt='Buy at Cardhoarder'
        eventLabel={prices.cardhoarder.url}
        key={v4()}
        target='_blank'
        title='Buy at Cardhoarder'
        to={prices.cardhoarder.url}
      >
        <div className={styles.price}>
          <span>{`${prices.cardhoarder.price} TIX`}</span>
        </div>
      </OutboundLink>
    ),
    cardkingdom: () => (
      <OutboundLink
        alt='Buy at Card Kingdom'
        eventLabel={cardkingdomUrl}
        key={v4()}
        target='_blank'
        title='Buy at Card Kingdom'
        to={cardkingdomUrl}
      >
        <div className={styles.price}>
          <svg
            height='12'
            version='1.1'
            viewBox='0 0 3.7041667 3.1750001'
            width='14'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g transform='translate(0 -293.82)'>
              <path d='m0 293.82v1.1592h0.52042v2.0158h2.6633v-2.0158h0.52042v-1.1592h-0.57636v1.0908h-0.49196v-1.084h-0.54839v1.084h-0.47074v-1.084h-0.54839v1.084h-0.49196v-1.0908z' />
            </g>
          </svg>
          <span>{`$${prices.cardkingdom.price.toFixed(2)}`}</span>
        </div>
      </OutboundLink>
    ),
    cardmarket: () => (
      <OutboundLink
        alt='Buy at Cardmarket'
        eventLabel={prices.cardmarket.url}
        key={v4()}
        rel='nofollow'
        target='_blank'
        title='Buy at Cardmarket'
        to={prices.cardmarket.url}
      >
        <div className={styles.price}>
          <span>
            {`${
              typeof prices.cardmarket.price === 'number' ? prices.cardmarket.price.toFixed(2) : prices.cardmarket.price
            } €`.replace('.', ',')}
          </span>
        </div>
      </OutboundLink>
    ),
    coolstuffinc: () => (
      <OutboundLink
        alt='Buy at CoolStuffInc'
        eventLabel={prices.coolstuffinc.url}
        key={v4()}
        target='_blank'
        title='Buy at CoolStuffInc'
        to={prices.coolstuffinc.url}
      >
        <div className={styles.price}>
          <svg width='24' height='12' version='1.1' viewBox='0 0 24 12' xmlns='http://www.w3.org/2000/svg'>
            <g transform='matrix(.056341 0 0 .056341 -.70313 -6.6902)'>
              <path d='m176.83 322.32c-17 6.11-36.63 9.17-58.89 9.17-21.88 0-40.74-4.18-56.6-12.54s-27.97-20.25-36.32-35.68c-8.36-15.43-12.54-33.22-12.54-53.37 0-21.68 4.68-40.98 14.04-57.89s22.59-29.97 39.69-39.19 36.77-13.83 59.03-13.83c17.77 0 34.96 2.15 51.58 6.45v57.17c-5.73-3.44-12.56-6.11-20.49-8.02s-15.95-2.87-24.07-2.87c-16.81 0-30.07 4.82-39.76 14.47-9.7 9.65-14.54 22.74-14.54 39.26 0 16.43 4.85 29.4 14.54 38.9 9.69 9.51 22.66 14.26 38.9 14.26 15 0 30.14-3.82 45.42-11.46v55.17z' />
              <path d='m351.49 265.72c0 13.66-3.65 25.55-10.96 35.68s-17.55 17.67-30.73 22.64-29.04 7.45-47.57 7.45c-21.49 0-41.17-3.63-59.03-10.89v-56.31c8.6 6.3 18.1 11.39 28.51 15.26s20.11 5.8 29.09 5.8c6.78 0 12.04-1.22 15.76-3.65 3.72-2.44 5.59-5.99 5.59-10.67 0-3.34-0.93-6.28-2.79-8.81s-4.68-4.89-8.45-7.09c-3.78-2.2-10.77-5.21-20.99-9.03-33.05-12.7-49.58-33.24-49.58-61.61 0-19.87 7.54-35.75 22.64-47.64 15.09-11.89 35.34-17.84 60.75-17.84 7.16 0 13.76 0.29 19.77 0.86s11.48 1.29 16.41 2.15c4.92 0.86 11.82 2.48 20.71 4.87v52.3c-17.29-9.46-34.29-14.19-51.01-14.19-6.88 0-12.42 1.29-16.62 3.87-4.21 2.58-6.3 6.11-6.3 10.6 0 4.3 1.7 7.86 5.09 10.67 3.39 2.82 10.48 6.47 21.28 10.96 21.3 8.6 36.37 18.01 45.21 28.23 8.8 10.22 13.22 22.35 13.22 36.39z' />
              <path d='m376.56 327.9v-205.47h61.9v205.47z' />
            </g>
          </svg>
          <span>{`$${prices.coolstuffinc.price}`}</span>
        </div>
      </OutboundLink>
    ),
    tcgplayer: () => (
      <OutboundLink
        alt='Buy at TCGplayer'
        eventLabel={tcgplayerUrl}
        key={v4()}
        target='_blank'
        title='Buy at TCGplayer'
        to={tcgplayerUrl}
      >
        <div className={styles.price}>
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 600 451">
          <path class="cls-2" d="M115.9,44.8l-84.9,12.6C11.1,60.3-2.5,78.7.4,98.4l42.4,283c3,19.7,21.4,33.3,41.3,30.4l31.8-4.7V44.8Z" style={{"fill": "#0968f6", "stroke-width": "0px"}}/>
          <path class="cls-2" d="M569,57.3l-83.8-12.4v362.3l30.7,4.6c19.8,2.9,38.3-10.7,41.3-30.4l42.4-283c3-19.7-10.7-38.1-30.6-41h0Z" style={{"fill": "#0968f6", "stroke-width": "0px"}}/>
          <path class="cls-2" d="M187.3,132.7h0s0,0,0,0Z" style={{"fill": "#0968f6", "stroke-width": "0px"}}/>
          <path class="cls-2" d="M187.3,132.7h0s0,0,0,0Z" style={{"fill": "#0968f6", "stroke-width": "0px"}}/>
          <path class="cls-1" d="M175,4.7h251.2c20.1,0,36.3,16.2,36.3,36.1v370.3c0,20-16.3,36.1-36.3,36.1h-251.2c-20.1,0-36.3-16.2-36.3-36.1V40.8c0-20,16.3-36.1,36.3-36.1ZM327.6,184.5h76.3c7.3,0,11.6,8.2,7.5,14.2l-108.6,157.7c-5.1,7.3-16.6,3.8-16.6-5.1v-81.8h0c0,0-89,0-89,0-6.7,0-11.1-7-8.2-13l75-154c1.5-3.1,4.7-5.1,8.2-5.1h83.3c6.7,0,11.1,7,8.2,13l-36.1,74.1Z" style={{"fill-rule": "evenodd", "fill": "#0968f6", "stroke-width": "0px"}}/>
        </svg>
          <span>{prices.tcgplayer.price > 0 ? `$${prices.tcgplayer.price.toFixed(2)}` : `$---`}</span>
        </div>
      </OutboundLink>
    ),
  }
  return (
    <div className={styles.prices}>
      {prices && (
        <>
          {[0, 1, 2].map((i) => {
            return prices[priceSources[i]] && priceLinks[priceSources[i]] ? (
              priceLinks[priceSources[i]]()
            ) : (
              <span key={v4()}>&nbsp;</span>
            )
          })}
        </>
      )}
    </div>
  )
}

CardPrices.propTypes = {}

export default CardPrices
